module.exports = __webpack_public_path__ + "static/media/map.ac7be85c.png";